module.exports = _.slice;


//////////////////
// WEBPACK FOOTER
// external "_.slice"
// module id = 1043
// module chunks = full-screen-modals/full-screen-modals mobile-overlay/mobile-overlay mobile/mobile dashboard/dashboard business-manager/video-library-page widget/widget